<template>
  <div class="container py-4" :class="themeClass">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="m-0">Proveedores</h3>
      <div>
        <router-link to="/proveedores/nuevo" class="btn btn-primary btn-sm">
          Nuevo Proveedor
        </router-link>
      </div>
    </div>

    <div class="row g-2 mb-3">
      <div class="col-md-6">
        <input v-model="search" @input="cargar" type="text" placeholder="Buscar por razón social" class="form-control form-control-sm" />
      </div>
      <div class="col-md-6 text-end">
        <button class="btn btn-outline-secondary btn-sm" :disabled="loading" @click="cargar">
          <span v-if="loading" class="spinner-border spinner-border-sm"></span>
          <span v-else>Refrescar</span>
        </button>
      </div>
    </div>

    <div class="card">
      <div class="table-responsive">
        <table class="table table-sm table-hover m-0">
          <thead class="table-light">
            <tr>
              <th style="width:70px;">ID</th>
              <th>Razón Social</th>
              <th>Identificación</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th>Estado</th>
              <th style="width:150px;">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="7" class="text-center py-4">
                <div class="spinner-border spinner-border-sm"></div>
              </td>
            </tr>
            <tr v-else-if="proveedores.length === 0">
              <td colspan="7" class="text-center py-4 text-muted">No hay proveedores</td>
            </tr>
            <tr v-for="p in proveedores" :key="p.id">
              <td>{{ p.id }}</td>
              <td>{{ p.business_name }}</td>
              <td>{{ p.identification_number }}</td>
              <td>{{ p.email || '-' }}</td>
              <td>{{ p.phone || '-' }}</td>
              <td>
                <span :class="['badge', p.is_active ? 'bg-success' : 'bg-secondary']">
                  {{ p.is_active ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
              <td>
                <div class="btn-group btn-group-sm">
                  <router-link :to="`/proveedores/ver/${p.id}`" class="btn btn-outline-info btn-sm" title="Ver">
                    <i class="fas fa-eye"></i>
                  </router-link>
                  <router-link :to="`/proveedores/editar/${p.id}`" class="btn btn-outline-warning btn-sm" title="Editar">
                    <i class="fas fa-edit"></i>
                  </router-link>
                  <button class="btn btn-outline-secondary btn-sm" :title="p.is_active ? 'Desactivar' : 'Activar'" @click="toggleStatus(p)">
                    <i :class="p.is_active ? 'fas fa-toggle-on' : 'fas fa-toggle-off'"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import supplierService from '@/services/supplierService';
import themeManager from '@/store/theme';
import notificationService from '@/services/notificationService';

export default {
  name: 'ProveedoresList',
  data() {
    return {
      proveedores: [],
      search: '',
      loading: false
    };
  },
  computed: {
    themeClass() {
      return themeManager.themeClass
    }
  },
  methods: {
    async cargar() {
      this.loading = true;
      try {
        const resp = await supplierService.listar(
          this.search ? { business_name: this.search } : {}
        );
        this.proveedores = resp.data || [];
      } catch (e) {
        console.error('Error cargando proveedores', e);
        this.mostrarNotificacion('No se pudieron cargar los proveedores', 'error');
      } finally {
        this.loading = false;
      }
    },
    async toggleStatus(proveedor) {
      const action = proveedor.is_active ? 'desactivar' : 'activar'
      const result = await window.Swal.fire({
        title: `${action.charAt(0).toUpperCase() + action.slice(1)} Proveedor`,
        text: `¿Está seguro de ${action} este proveedor?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: proveedor.is_active ? '#dc3545' : '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: `Sí, ${action}`,
        cancelButtonText: 'Cancelar'
      })

      if (!result.isConfirmed) return

      try {
        await supplierService.actualizar(proveedor.id, {
          is_active: !proveedor.is_active
        });
        // Recargar la lista
        await this.cargar();
        this.mostrarNotificacion(`Proveedor ${action}do exitosamente`, 'success');
      } catch (e) {
        console.error('Error cambiando estado del proveedor', e);
        this.mostrarNotificacion('Error al cambiar el estado del proveedor', 'error');
      }
    },
    mostrarNotificacion(mensaje, tipo = 'info') {
      if (tipo === 'success') notificationService.success(mensaje);
      else if (tipo === 'error') notificationService.error(mensaje);
      else notificationService.info(mensaje);
    }
  },
  mounted() {
    this.cargar();
  }
}
</script>